module.exports = __webpack_public_path__ + "static/media/calender-blue.e65dd4ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/calender-blue.svg
// module id = 1047
// module chunks = 0